import { combineReducers } from '@reduxjs/toolkit'
import {
  LICENSES_COLLAPSE_STATE_REDUCER_NAME,
  IMPORT_LICENSE_REDUCER_NAME,
  LICENSES_LIST_REDUCER_NAME,
  LICENSES_NOTE_UPDATE_REDUCER_NAME,
  RECLAIM_LICENSE_REDUCER_NAME,
  TRANSFER_LICENSE_REDUCER_NAME,
} from './consts'
import {
  licenesCollapseStateReducer,
  importLicenseReducer,
  licensesListReducer,
  reclaimLicenseReducer,
  transferLicenseReducer,
  updateLicenseNoteReducer,
} from './slice'

export default combineReducers({
  [LICENSES_LIST_REDUCER_NAME]: licensesListReducer,
  [LICENSES_NOTE_UPDATE_REDUCER_NAME]: updateLicenseNoteReducer,
  [IMPORT_LICENSE_REDUCER_NAME]: importLicenseReducer,
  [RECLAIM_LICENSE_REDUCER_NAME]: reclaimLicenseReducer,
  [TRANSFER_LICENSE_REDUCER_NAME]: transferLicenseReducer,
  [LICENSES_COLLAPSE_STATE_REDUCER_NAME]: licenesCollapseStateReducer,
})
